import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Typography } from "@mui/material";

const getInitials = (name = "") =>
  name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

const CommentItem = ({ comment }) => {
  const { author_name, author_role, created_at, body } = comment ?? {};

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
        <Avatar
          sx={{
            width: 36,
            height: 36,
            fontSize: 13,
            fontWeight: 700,
            bgcolor: "var(--color-primary-100)",
            color: "var(--color-primary-700)",
            flexShrink: 0,
          }}
        >
          {getInitials(author_name)}
        </Avatar>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 600,
              lineHeight: "20px",
              color: "var(--color-foreground-muted)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {author_name}
          </Typography>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 400,
              lineHeight: "16px",
              color: "var(--color-neutral-400)",
            }}
          >
            {author_role}
            {author_role && created_at ? " · " : ""}
            {created_at}
          </Typography>
        </Box>
      </Box>

      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 400,
          lineHeight: "20px",
          color: "var(--color-neutral-700)",
          p: 2,
          bgcolor: "var(--color-neutral-0)",
          borderRadius: "var(--rounded-lg)",
          border: "1px solid var(--color-neutral-100)",
        }}
      >
        {body}
      </Typography>
    </Box>
  );
};

CommentItem.propTypes = {
  comment: PropTypes.shape({
    author_name: PropTypes.string,
    author_role: PropTypes.string,
    created_at: PropTypes.string,
    body: PropTypes.string,
  }),
};

CommentItem.defaultProps = {
  comment: null,
};

export default CommentItem;
